<template>
  <main>
    <sub-tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-6">
                    <h4 class="text-green d-inline-block m-0 align-middle">選擇撥出對象</h4>
                    <div class="tags d-inline-block">
                        <div class="tag" v-for="(out, oid) in form.dialOut" :key="`dialout-tag-${oid}`">
                            {{out.name}} {{out.no}}
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <h4 class="text-green d-inline-block m-0 align-middle">選擇撥入對象</h4>
                    <div class="tags d-inline-block">
                        <div class="tag" v-for="(din, did) in form.dialIn" :key="`dialin-tag-${did}`">
                            {{din.name}} {{din.no}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <form class="form">
          <div class="container" v-if="!mapMode">
              <div class="row">
                    <div class="col-12">
                        <h4 class="text-green mt-0">整合篩選</h4>
                    </div>
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="client-name" class="col-3 text-right">客戶姓名</label>
                            <div class="col-6">
                                <input type="text" v-model="form.clientName" id="client-name" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="col-7">
                        <div class="form-group row">
                            <label for="charger" class="col-3 text-right">收費人員</label>
                            <div class="col-3">
                                <select name="" id="" class="form-control">
                                    <option value="">請選擇</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <input type="text" v-model="form.charger[1]" class="form-control" placeholder="請輸入姓名">
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="charger" class="col-3 text-right">VIP</label>
                            <div class="col-6">
                                <select name="" id="charger" class="form-control">
                                    <option value="">請選擇</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-7">
                        <div class="form-group row">
                            <label for="self" class="col-3 text-right">自招</label>
                            <div class="col-6">
                                <select v-model="form.self" id="self" class="form-control">
                                    <option value="">請選擇</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="" class="col-3 text-right">整合地址</label>
                            <div class="col-4">
                                <select  v-model="form.address[0]" class="form-control">
                                    <option value="">縣市</option>
                                </select>
                            </div>
                            <div class="col-5">
                                <select  v-model="form.address[1]" class="form-control">
                                    <option value="">鄉鎮市區</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <input type="text" v-model="form.address[2]" class="form-control" placeholder="路段名稱">
                    </div>
                    <div class="col-3 text-right">
                        <button class="btn btn-primary m-0">篩選</button>
                    </div>
              </div>

          </div>
          <div class="container" v-else>
              <div class="row">
                    <div class="col-12">
                        <h4 class="text-green mt-0">地圖篩選</h4>
                    </div>
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="client-name" class="col-3 text-right">客戶姓名</label>
                            <div class="col-6">
                                <input type="text" v-model="form.clientName" id="client-name" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="col-12"></div>
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="" class="col-3 text-right">整合地址</label>
                            <div class="col-4">
                                <select  v-model="form.address[0]" class="form-control">
                                    <option value="">縣市</option>
                                </select>
                            </div>
                            <div class="col-5">
                                <select  v-model="form.address[1]" class="form-control">
                                    <option value="">鄉鎮市區</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <input type="text" v-model="form.address[2]" class="form-control" placeholder="路段名稱">
                    </div>
                    <div class="col-3 text-right">
                        <button class="btn btn-primary m-0">篩選</button>
                    </div>
              </div>
              <div id="gmap">

              </div>
          </div>
          <div class="container">
            <div class="row">
                <div class="col-6">
                    <!--<a class="btn btn-default" :disabled="!resultSelection.length" @click="mapMode=!mapMode">
                        <span v-if="!mapMode">檢視地圖模式</span>
                        <span v-else>返回列表模式</span>
                    </a>-->
                </div>
                <div class="col-6 text-right">
                    <router-link to="/tab/1" class="btn btn-default">
                        上一步
                    </router-link>
                    <a class="btn btn-primary" @click="doConfirm()">
                        下一步
                    </a>
                </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    
    <warning-modal
    :open="warnModalOpen"
    :selection="resultSelection"
    :message="warnModalMsg"
    @submit="doSubmit"
    @close="panelClose('warnModalOpen')"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import DialOutPersonModal from '@/desktop/components/submanager/DialOutPersonModal'
import DialInPersonModal from '@/desktop/components/submanager/DialInPersonModal'
import SubTabHeader from '@/desktop/components/submanager/TabHeader'
import WarningModal from '@/desktop/components/WarningModal'
import Avatar from '@/components/Avatar'
import Level from '@/components/Level'
import { debuglog } from 'util';

export default {
  name: 'TransferTab1Filter',
  mixins: [commonMixin],
  components: {
    SubTabHeader, 
    DialOutPersonModal, DialInPersonModal, WarningModal, Level, Avatar
  },
  computed: {
  },
  data () {
    return {
      mapMode: false,
      warnModalOpen: false,
      warnModalMsg: '',
      resultSelection: [],
      checkAll: false,
      form: {
        dialOut: [
            {
                name: '吳和龍',
                no: 'FN52099'
            },
            {
                name: '成龍',
                no: 'FN52510'
            }
        ],
        dialIn: [
            {
                name: '羅志祥 ',
                no: 'FN52512'
            }
        ],
        selected: [],
        clientName: '',
        charger: ['', ''],
        vip: '',
        self: '',
        address: ['', '', '']
      },
      tableOpt: {
        checkAll: true,
        columns: [
          {
            name: 'no',
            label: '保單號碼',
          }, {
            name: 'name',
            label: '客戶姓名',
          }, {
            name: 'no',
            label: '現行收<br/>買人員',
            template: (row) => {
              return `${ row.charger }<br/>${ row.chargerNo }`
            }
          }, {
            name: 'self',
            label: '自招件',
            template: (row) => {
              return (row.self ? '' : '非') + '自招'
            }
          }, {
            name: 'address',
            label: '整合地址',
          }, {
            name: 'validity',
            label: '契約<br/>效力',
            template: (row) => {
              switch(row.validity) {
                case 1:
                  return '<span>正常</span>'
                case 2:
                  return '<span>終身險<br/>滿期</span>'
                case 3:
                  return '<span>繳清件</span>'
              }
            }
          }, {
            name: 'preCharger',
            label: '前一收<br/>買人員',
            template: (row) => {
              return `${ row.preCharger }<br/>${ row.preChargerNo }`
            }
          }, {
            name: 'nextAt',
            label: '下次<br/>應繳日',
          }, {
            name: 'endAt',
            label: '調撥<br/>截止日',
          }
        ]
      },
      searchResult: [
          {
              id: 1,
              no: '5659011234',
              name: '陳怡君',
              vip_level: 1,
              sex: 1,
              charger: '吳和龍',
              chargerNo: 'FN52099',
              self: false,
              address: '台北市中山區民族東路410巷2弄18號',
              validity: 1,
              preCharger: '陳怡君',
              preChargerNo: 'FN51333',
              nextAt: '108/03/15',
              endAt: '108/03/22'
          },
          {
              id: 2,
              no: '5659011234',
              name: '陳怡君',
              vip_level: 0,
              sex: 2,
              charger: '吳和龍',
              chargerNo: 'FN52099',
              self: false,
              address: '台北市中山區民族東路410巷2弄18號',
              validity: 2,
              preCharger: '陳怡君',
              preChargerNo: 'FN51333',
              nextAt: '108/03/15',
              endAt: '108/03/22'
          },
          {
              id: 3,
              no: '5659011234',
              name: '陳怡君',
              vip_level: '3',
              sex: 1,
              charger: '吳和龍',
              chargerNo: 'FN52099',
              self: false,
              address: '台北市中山區民族東路410巷2弄18號',
              validity: 3,
              preCharger: '陳怡君',
              preChargerNo: 'FN51333',
              nextAt: '108/03/15',
              endAt: '108/03/22'
          }
      ]
    }
  },
  watch: {
      'checkAll': 'doCheckAll'
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    doSubmit () {
        // Call API

        this.panelClose('warnModalOpen')
        this.$toast.info({ title: "服務件調撥已完成！" });
        this.$router.push({
            name: 'index'
        })
    },
    doConfirm () {
        this.warnModalMsg = "你是否確認要進行服務件調撥？"
        this.panelOpen('warnModalOpen')
    },
    doCheckAll(val) {
        if(!val)
            this.form.selected = []
        else
            this.searchResult.forEach(r => {
                this.form.selected.push(r.id)
            })
    },
    updateSelection (selection) {
      this.resultSelection = selection
    }
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>
